export function isNull(value: unknown): value is null | undefined {
  return value == null;
}

export function isNotNull<T>(value: T | null | undefined): value is T {
  return !isNull(value);
}
